/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-29-10 08:00:00
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { DataTable, Checkbox } from '@shopify/polaris';
import { Field } from 'redux-form';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import TableHeadingCellWithTooltip from 'src/components/views/redirect/table-heading-cell-with-tooltip';

type Props = {
  skip: number,
  limit: number,
  discardDeletingChange: boolean,
  handleChangeDeletingButtonGroup: () => void,
  turnOffDiscardDeletingChangeFlag: () => void
};

type ComposedProps = Props & WithI18nProps;

type State = {
  redirects: Array<Object>
};

class RedirectsEdit extends Component<ComposedProps, State> {
  state = {
    redirects: []
  };

  componentDidMount() {
    const { fields } = this.props;
    const redirects = fields.map((redirect, index) => {
      return {
        index,
        selected: false
      };
    });

    this.setState({ redirects });
  }

  componentWillReceiveProps(nextProps) {
    const { fields, skip, limit, discardDeletingChange } = nextProps;
    const { fields: fieldsPrev, skip: skipPrev, limit: limitPrev } = this.props;

    // Init selection if change the page
    // - Number of fields is changed
    // - Change the page with pagination
    // - Discard selected redirect
    if (
      fields.length !== fieldsPrev.length ||
      skip !== skipPrev ||
      limit !== limitPrev ||
      discardDeletingChange
    ) {
      const redirects = fields.map((redirect, index) => {
        return {
          index,
          selected: false
        };
      });

      this.setState({ redirects });
      this.props.turnOffDiscardDeletingChangeFlag();
    }
  }

  render() {
    const { i18n } = this.props;

    // Render redirects on table
    const rowRedirects = this.buildRows();

    return (
      <DataTable
        verticalAlign="middle"
        columnContentTypes={['text', 'text', 'text']}
        headings={[
          i18n.translate('AdminHTML.Redirects.Redirects.status'),
          <TableHeadingCellWithTooltip
            heading={i18n.translate('AdminHTML.Redirects.Redirects.searchTerm')}
            tooltipContent={i18n.translate('AdminHTML.Redirects.Redirects.searchTerm_Tooltip')}
          />,
          i18n.translate('AdminHTML.Redirects.Redirects.redirectTo'),
          i18n.translate('AdminHTML.Redirects.Redirects.delete')
        ]}
        rows={rowRedirects}
      />
    );
  }

  // Render rows for data table
  buildRows = () => {
    const { i18n, fields } = this.props;
    const rows = fields.map((redirect, index) => {
      const selected = _.get(this.state, `redirects[${index}].selected`);
      return [
        <Field name={`${redirect}.enabled`} component={RenderToggleSwitch} />,
        <Field
          name={`${redirect}.terms`}
          component={RenderTextField}
          placeholder={i18n.translate('AdminHTML.Redirects.Redirects.searchTerm_Placeholder')}
        />,
        <Field
          name={`${redirect}.redirectTo`}
          component={RenderTextField}
          placeholder={i18n.translate('AdminHTML.Redirects.Redirects.redirectTo_Placeholder')}
        />,
        <Checkbox checked={selected} onChange={() => this.handleSelect(index)} />
      ];
    });

    return rows;
  };

  // Update state for selected term
  handleSelect = termIndex => {
    let { redirects } = this.state;
    const selected = redirects[termIndex] ? redirects[termIndex].selected : false;
    redirects[termIndex].selected = !selected;

    this.setState({ redirects });

    // Check show/hide deleting menu
    this.showDeletingButtons();
  };

  // Handle show/hide deleting buttons
  showDeletingButtons = () => {
    const { handleChangeDeletingButtonGroup } = this.props;
    const { redirects } = this.state;

    // Check if having seleted term to be deleted
    const selectedRedirects = _.filter(redirects, { selected: true });

    // Show/Hide deleting buttons
    if (!_.isEmpty(selectedRedirects)) {
      handleChangeDeletingButtonGroup(true, selectedRedirects);
    } else {
      handleChangeDeletingButtonGroup(false, selectedRedirects);
    }
  };
}

export default withI18n()(RedirectsEdit);
